var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.186047 17.8295C0.310077 17.9535 0.465116 18.0155 0.635659 18.0155C0.806201 18.0155 0.96124 17.9535 1.08527 17.8295L9.00775 9.90698L16.9302 17.8295C17.0543 17.9535 17.2093 18.0155 17.3798 18.0155C17.5349 18.0155 17.7054 17.9535 17.8295 17.8295C18.0775 17.5814 18.0775 17.1783 17.8295 16.9302L9.90698 9.00775L17.8295 1.08527C18.0775 0.837209 18.0775 0.434109 17.8295 0.186047C17.5814 -0.0620155 17.1783 -0.0620155 16.9302 0.186047L9.00775 8.10853L1.08527 0.186047C0.837209 -0.0620155 0.434108 -0.0620155 0.186047 0.186047C-0.0620155 0.434109 -0.0620155 0.837209 0.186047 1.08527L8.10853 9.00775L0.186047 16.9302C-0.0620155 17.1783 -0.0620155 17.5814 0.186047 17.8295Z",
    fill: "#ABAFB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey);
export default __webpack_public_path__ + "static/media/close-grey.13203342303877c41964852e96b23868.svg";
export { ForwardRef as ReactComponent };